/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageOrgsListAll } from '../../models/page-orgs-list-all';

export interface GetAllOrgRecordsApiV2MembersOrgsAllGet$Params {
  name?: (string | null);
  excludeDeleted?: boolean;
  org: string;

/**
 * Page number
 */
  page?: number;

/**
 * Page size
 */
  size?: number;
}

export function getAllOrgRecordsApiV2MembersOrgsAllGet(http: HttpClient, rootUrl: string, params: GetAllOrgRecordsApiV2MembersOrgsAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PageOrgsListAll>> {
  const rb = new RequestBuilder(rootUrl, getAllOrgRecordsApiV2MembersOrgsAllGet.PATH, 'get');
  if (params) {
    rb.query('name', params.name, {});
    rb.query('excludeDeleted', params.excludeDeleted, {});
    rb.query('org', params.org, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageOrgsListAll>;
    })
  );
}

getAllOrgRecordsApiV2MembersOrgsAllGet.PATH = '/api/v2/members/orgs/all';
